import React, { createContext, useContext, useRef, useState } from 'react';

interface MediaContextType {
  currentlyPlaying: 'audio' | 'video' | null;
  audioRef: React.RefObject<any>;
  setCurrentlyPlaying: (type: 'audio' | 'video' | null) => void;
  stopAllMedia: () => void;
}

const MediaContext = createContext<MediaContextType | undefined>(undefined);

export const MediaProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentlyPlaying, setCurrentlyPlaying] = useState<'audio' | 'video' | null>(null);
  const audioRef = useRef<any>(null);

  const stopAllMedia = () => {
    // Stop audio player if it exists
    if (audioRef.current?.audio?.current) {
      audioRef.current.audio.current.pause();
    }
    
    // Stop all YouTube videos
    const iframes = document.querySelectorAll('iframe[src*="youtube.com"]');
    iframes.forEach((iframe: any) => {
      const src = iframe.src;
      iframe.src = '';
      iframe.src = src;
    });
    
    setCurrentlyPlaying(null);
  };

  return (
    <MediaContext.Provider value={{
      currentlyPlaying,
      audioRef,
      setCurrentlyPlaying,
      stopAllMedia
    }}>
      {children}
    </MediaContext.Provider>
  );
};

export const useMedia = () => {
  const context = useContext(MediaContext);
  if (!context) {
    throw new Error('useMedia must be used within a MediaProvider');
  }
  return context;
};